/**
 * @param reStr - a string to be converted to regex, case insensitive
 * @param str - a string to search
 * @return boolean - based on whether the str param contains a case-insensitive
 * (substring of the regex
 */
export function stringToRegexSearch(reStr, str) {
  if (!reStr || !str) {
    return false;
  }

  const regex = new RegExp(reStr, 'i');

  return str.search(regex) > -1;
}
/**
 * This is non-destrucive
 * @param subStr - a string to be removed
 * @param fromStr - a string, the beginning from which subStr should be removed
 * @return string - a new string in which subStr has been remove from the beginning of fromStr
 */
export function sliceStartFromStr(subStr, fromStr) {
  if (!subStr || !fromStr || !fromStr.startsWith(subStr)) {
    return '';
  }

  const removeLength = fromStr.length;
  const strToRemoveUntil = subStr.length;

  return fromStr.slice(strToRemoveUntil, removeLength);
}



// WEBPACK FOOTER //
// ./shared/lib/string-helpers/index.js